import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'
import { JobAssessmentCard } from './types'
import { formatResponse } from './utils'

type InitialStateType = {
  fetching: boolean
  assessment_card: JobAssessmentCard
}

const initialState: InitialStateType = {
  assessment_card: {
    id: 0,
    created_by_id: 0,
    is_assessor: false,
    is_owner: false,
    assessment_card_resources_attributes: {
      assessors: [],
      card_owners: [],
    },
    assessment_skills_attributes: [],
    deleted_assessment_skills_attributes: [],
    job_id: 0,
    title: '',
  },
  fetching: false,
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.CREATE_JOB_ASSESSMENT_CARD_PENDING:
    case actions.UPDATE_JOB_ASSESSMENT_CARD_PENDING:
    case actions.DELETE_JOB_ASSESSMENT_CARD_PENDING:
    case actions.GET_JOB_ASSESSMENT_CARD_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }
    case actions.DELETE_JOB_ASSESSMENT_CARD_FULFILLED: {
      return {
        ...state,
        assessment_card: initialState.assessment_card,
        fetching: false,
      }
    }

    case actions.CREATE_JOB_ASSESSMENT_CARD_FULFILLED:
    case actions.UPDATE_JOB_ASSESSMENT_CARD_FULFILLED:
    case actions.GET_JOB_ASSESSMENT_CARD_FULFILLED: {
      if (
        ['CREATE_JOB_ASSESSMENT_CARD_FULFILLED', 'UPDATE_JOB_ASSESSMENT_CARD_FULFILLED'].includes(
          action.type,
        )
      ) {
        Toastr.success(action.payload.data.data.message)
      }
      const assessmentCard = action.payload.data.data.assessment_card
      return {
        ...state,
        assessment_card: assessmentCard
          ? formatResponse(action.payload.data.data)
          : initialState.assessment_card,
        fetching: false,
      }
    }

    case actions.CREATE_JOB_ASSESSMENT_CARD_REJECTED:
    case actions.UPDATE_JOB_ASSESSMENT_CARD_REJECTED:
    case actions.DELETE_JOB_ASSESSMENT_CARD_REJECTED:
    case actions.GET_JOB_ASSESSMENT_CARD_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }

    default:
      return state
  }
}
